import { Grid, Paper, Tab, Tabs } from "@mui/material";

import TabLabel from "components/pages/transmissions/tabs/label/TabLabel";
import useTaskTabs from "./useTaskTabs";

const TaskTabs = ({ selectedTab, isLoading }) => {
  const { tabs, role, onTabChange } = useTaskTabs(selectedTab);

  return (
    <>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Paper
            square
            elevation={0}
            style={{
              position: "relative",
              top: "1px",
              zIndex: 1000,
              backgroundColor: "transparent",
            }}
          >
            <Tabs
              onChange={(_event, value) => {
                isLoading === false &&
                  selectedTab !== value &&
                  onTabChange(value);
              }}
              value={selectedTab}
              indicatorColor="secondary"
              TabIndicatorProps={{
                style: { top: 0, borderBottom: "none" },
              }}
              textColor="secondary"
            >
              {tabs.map(
                ({ label, value, scope, style }, index) =>
                  scope.includes(role) && (
                    <Tab
                      key={index}
                      disabled={isLoading}
                      style={style}
                      value={value}
                      sx={{ fullWidth: true }}
                      label={<TabLabel label={label} count={0} />}
                    />
                  )
              )}
            </Tabs>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default TaskTabs;
